import { getAllWorkflowUser } from "./get-all-statusworkflow";
import { getAllStatus } from "./status/get-all-status";
import { createStatus, updateStatus } from "./status/status";
import {
  createSingleCategory,
  createWorkflow,
  getAllCategory,
  getAllWorkflow,
  removeWorkFlowCategory,
  updateWorkfloeSingle,
} from "./workflow/workflow";

export const status = {
  createStatus,
  getAllStatus,
  updateStatus,
  getAllCategory,
  createSingleCategory,
  getAllWorkflow,
  createWorkflow,
  updateWorkfloeSingle,
  removeWorkFlowCategory,
  getAllWorkflowUser,
};
